import React, { useState, useRef, useEffect } from 'react';
import { ProfileContainer } from './style';
import EditIcon from '@design-system/Assets/EditIcon';
import { Form, TextInput } from '@design-system/';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { get_profile_details, update_profile } from './redux/reducer';
import { getLoading, getProfileDetails } from './redux/selectors';
import Password from './changePassword';

const ProfilePage = () => {
  const [image, setImage] = useState('');
  const imgRef = useRef();
  const dispatch = useDispatch();
  const profile = useSelector(getProfileDetails);
  const loading = useSelector(getLoading);
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    dispatch(get_profile_details());
  }, [dispatch]);

  const selectImage = (e) => {
    setImage(e.target.files[0]);
  };

  const handleOpenImage = () => {
    imgRef.current?.click();
  };

  const formik = useFormik({
    initialValues: {
      first_name: profile.first_name || '',
      last_name: profile.last_name || '',
      phone: profile.phone || '',
    },

    enableReinitialize: true,

    onSubmit: async (data) => {
      if (typeof image !== 'string') {
        dispatch(update_profile({ ...data, photo_url: image }));
      } else {
        dispatch(update_profile(data));
      }
    },
  });

  return (
    <>
      <ProfileContainer>
        <Form onSubmit={formik.handleSubmit}>
          <div className="profile_header">
            <div>
              <div className="profile_title">Profile</div>
            </div>

            <div className="button_container">
              {!edit ? (
                <button
                  className={!edit ? 'profile_button' : 'active'}
                  onClick={() => setEdit(!edit)}
                >
                  Edit
                </button>
              ) : (
                <div className="profile_edit">
                  <button
                    className="profile_cancel_button"
                    onClick={() => setEdit(!edit)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="profile_save_button">
                    {loading ? 'Saving...' : 'Save Change'}
                  </button>
                </div>
              )}
            </div>
          </div>

          <section className="profile_form">
            <div className="profile_form_content">
              <label className="profile_form_label">Profile Photo</label>
              <div className="profile_avatar_upload">
                <input
                  type="file"
                  accept=".png, .jpg, .jpeg"
                  ref={imgRef}
                  onChange={(e) => selectImage(e)}
                  style={{ display: 'none' }}
                />

                {edit ? (
                  image !== '' || profile.photo_url ? (
                    <img
                      src={image ? URL.createObjectURL(image) : profile.photo_url}
                      alt="profile"
                      className="profile_image"
                    />
                  ) : (
                    <div className="profile_image_default">
                      {profile?.first_name?.slice(0, 1)}
                      {profile?.last_name?.slice(0, 1)}
                    </div>
                  )
                ) : profile.photo_url ? (
                  <img
                    src={profile.photo_url}
                    alt="profile"
                    className="profile_image"
                  />
                ) : (
                  <div className="profile_image_default">
                    {profile?.first_name?.slice(0, 1)}
                    {profile?.last_name?.slice(0, 1)}
                  </div>
                )}
                {!edit ? null : (
                  <label className="profile_icon" onClick={handleOpenImage}>
                    {' '}
                    <EditIcon />
                  </label>
                )}
              </div>
            </div>

            <div className="profile_form_content">
              <label className="profile_form_label">Name</label>
              <div className="profile_input_content">
                <TextInput
                  name="first_name"
                  type="text"
                  id="firstname"
                  disabled={!edit ? true : false}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.first_name}
                />
                <TextInput
                  name="last_name"
                  type="text"
                  id="lastname"
                  disabled={!edit ? true : false}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.last_name}
                  error={
                    formik.touched.last_name &&
                    formik.errors.last_name &&
                    formik.errors.last_name
                  }
                ></TextInput>
              </div>
            </div>

            <div className="profile_form_content">
              <label className="profile_form_label">Phone Number</label>
              <TextInput
                name="phone"
                type="tel"
                id="phone"
                disabled={!edit ? true : false}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.phone}
              ></TextInput>
            </div>

            <div className="profile_form_content">
              <label className="profile_form_label">Email Address</label>
              <TextInput
                name="email"
                type="email"
                id="email"
                value={profile.email}
                disabled
              ></TextInput>
            </div>
          </section>
        </Form>
      </ProfileContainer>

      <Password />
    </>
  );
};

export default ProfilePage;
